import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import useRequest from "../../../api/useRequest";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CarouselsRequestFactory } from "../../../api/requestFactory";
import { NotificationContext } from "../../../context/notification-context";

function Nav({ hideTextToCarousel }) {
  const { requestMaker } = useRequest();
  const { showNotification } = React.useContext(NotificationContext);
  const [count, setCount] = React.useState(0);
  const { state } = useLocation();

  let isSaved = window.location.pathname === "/ai/carousels/saved";
  let isCarouselGenerator =
    window.location.pathname === "/ai/carousels/carousel-generator";

  useEffect(() => {
    requestMaker(CarouselsRequestFactory.createGetCarouselsCountRequest())
      .then((response) => {
        setCount(response.count);
      })
      .catch((error) => {
        console.error(error);
        showNotification(
          {
            title: "Something went wrong",
            content: "Please try again later",
          },
          "error"
        );
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestMaker]);

  const activeClass =
    "flex items-center gap-2 px-1 pt-2 pb-4 text-base font-semibold text-blue-500 border-b-2 border-blue-500 whitespace-nowrap";
  const inactiveClass =
    "flex items-center gap-2 px-1 pt-2 pb-4 text-base font-semibold text-gray-500 border-b-2 border-transparent hover:border-gray-200 hover:text-gray-700 whitespace-nowrap";

  return (
    <div className="border-b border-gray-200">
      <nav className="flex -mb-px space-x-6" aria-label="Tabs">
        <Link
          to="/ai/carousels"
          state={state}
          title=""
          className={
            isSaved || isCarouselGenerator ? inactiveClass : activeClass
          }
        >
          Templates
        </Link>
        <Link
          to="/ai/carousels/saved"
          title=""
          state={state}
          className={isSaved ? activeClass : inactiveClass}
          aria-current="page"
        >
          Saved
          <span className="bg-blue-500 text-white  rounded-full py-0.5 px-2.5 text-xs font-medium">
            {count}
          </span>
        </Link>
        {!hideTextToCarousel && (
          <Link
            to="/ai/carousels/carousel-generator"
            title=""
            className={isCarouselGenerator ? activeClass : inactiveClass}
          >
            Text to Carousel
          </Link>
        )}
      </nav>
    </div>
  );
}

export default Nav;
